import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let CustomLayout = class CustomLayout extends Vue {
  normalizePosition(position) {
    return String(position !== null && position !== void 0 ? position : '').trim();
  }
  get normalizedEngravingLookup() {
    try {
      var _this$$store$state, _rawSource$data, _rawSource$data2;
      // @ts-ignore
      const rawSource = (_this$$store$state = this.$store.state) === null || _this$$store$state === void 0 || (_this$$store$state = _this$$store$state.configurator) === null || _this$$store$state === void 0 || (_this$$store$state = _this$$store$state.user) === null || _this$$store$state === void 0 ? void 0 : _this$$store$state.clientEngravingConfigurations;
      const raw = (rawSource === null || rawSource === void 0 ? void 0 : rawSource.configurationsByItemCode) || (rawSource === null || rawSource === void 0 || (_rawSource$data = rawSource.data) === null || _rawSource$data === void 0 ? void 0 : _rawSource$data.configurationsByItemCode) || (rawSource === null || rawSource === void 0 ? void 0 : rawSource.configurations) || (rawSource === null || rawSource === void 0 || (_rawSource$data2 = rawSource.data) === null || _rawSource$data2 === void 0 ? void 0 : _rawSource$data2.configurations) || rawSource;
      if (!raw) return {
        __default__: {}
      };
      if (typeof raw === 'string') {
        try {
          return this.normalizeEngravingPayload(JSON.parse(raw));
        } catch (e) {
          return {
            __default__: {}
          };
        }
      }
      return this.normalizeEngravingPayload(raw);
    } catch (e) {
      return {
        __default__: {}
      };
    }
  }
  normalizeEngravingPayload(raw) {
    if (Array.isArray(raw)) {
      const defaults = {};
      raw.forEach(entry => {
        var _ref, _entry$engraving_posi;
        const position = this.normalizePosition((_ref = (_entry$engraving_posi = entry === null || entry === void 0 ? void 0 : entry.engraving_position) !== null && _entry$engraving_posi !== void 0 ? _entry$engraving_posi : entry === null || entry === void 0 ? void 0 : entry.position) !== null && _ref !== void 0 ? _ref : entry === null || entry === void 0 ? void 0 : entry.engravingPosition);
        if (position) defaults[position] = entry;
      });
      return {
        __default__: defaults
      };
    }
    if (raw && typeof raw === 'object') {
      const normalized = {};
      Object.entries(raw).forEach(([scopeKey, scopeValue]) => {
        if (!scopeValue || typeof scopeValue !== 'object') return;
        normalized[scopeKey] = {};
        Object.entries(scopeValue).forEach(([positionKey, positionValue]) => {
          const normalizedPosition = this.normalizePosition(positionKey);
          if (!normalizedPosition) return;
          normalized[scopeKey][normalizedPosition] = {
            engraving_position: normalizedPosition,
            ...positionValue
          };
        });
      });
      if (!normalized.__default__) normalized.__default__ = {};
      return normalized;
    }
    return {
      __default__: {}
    };
  }
  get currentItemCode() {
    var _this$$store$state2;
    // @ts-ignore
    return String(((_this$$store$state2 = this.$store.state) === null || _this$$store$state2 === void 0 || (_this$$store$state2 = _this$$store$state2.configurator) === null || _this$$store$state2 === void 0 || (_this$$store$state2 = _this$$store$state2.frontale) === null || _this$$store$state2 === void 0 ? void 0 : _this$$store$state2.ItemCode) || '').trim();
  }
  get engravingPositionKey() {
    const key = String(this.fieldGetterName || '');
    if (key === 'extDxName') return '45583';
    if (key === 'intDxName') return '45585';
    if (key === 'intSxName') return '45584';
    if (key === 'extSxName') return '45586';
    return null;
  }
  get engravingPositionAliases() {
    const key = String(this.fieldGetterName || '');
    if (key === 'extDxName') return ['45583', 'extDx', 'ext_dx', 'dx_ext', 'astaDxExt'];
    if (key === 'intDxName') return ['45585', 'intDx', 'int_dx', 'dx_int', 'astaDxInt'];
    if (key === 'intSxName') return ['45584', 'intSx', 'int_sx', 'sx_int', 'astaSxInt'];
    if (key === 'extSxName') return ['45586', 'extSx', 'ext_sx', 'sx_ext', 'astaSxExt'];
    return [];
  }
  normalizePositionValue(configItem) {
    return this.normalizePosition((configItem === null || configItem === void 0 ? void 0 : configItem.engraving_position) || (configItem === null || configItem === void 0 ? void 0 : configItem.position) || (configItem === null || configItem === void 0 ? void 0 : configItem.engravingPosition) || (configItem === null || configItem === void 0 ? void 0 : configItem.position_key) || '');
  }
  matchByPositionAliases(bucket, aliases) {
    if (!bucket) return null;
    for (const [positionKey, value] of Object.entries(bucket)) {
      const normalizedPosition = this.normalizePosition(positionKey).toLowerCase();
      if (aliases.some(alias => alias.toLowerCase() === normalizedPosition)) {
        return value;
      }
    }
    return null;
  }
  resolveEngravingForCurrentModel() {
    var _this$$store$getters;
    if (!this.engravingPositionAliases.length) return null;
    // Prefer centralized getter from configurator-base-app, if available.
    const getterFn = // @ts-ignore
    (_this$$store$getters = this.$store.getters) === null || _this$$store$getters === void 0 ? void 0 : _this$$store$getters['configurator/user/getStandardEngraving'];
    if (typeof getterFn === 'function') {
      for (const alias of this.engravingPositionAliases) {
        const found = getterFn(this.currentItemCode, alias);
        if (found) return found;
      }
    }
    const byModel = this.matchByPositionAliases(this.normalizedEngravingLookup[this.currentItemCode], this.engravingPositionAliases);
    if (byModel) return byModel;
    return this.matchByPositionAliases(this.normalizedEngravingLookup.__default__, this.engravingPositionAliases);
  }
  get currentPredefinedConfig() {
    return this.resolveEngravingForCurrentModel();
  }
  get isPredefined() {
    return !!this.currentPredefinedConfig;
  }
  get predefinedText() {
    var _this$currentPredefin, _this$currentPredefin2;
    const raw = ((_this$currentPredefin = this.currentPredefinedConfig) === null || _this$currentPredefin === void 0 ? void 0 : _this$currentPredefin.engraving) || ((_this$currentPredefin2 = this.currentPredefinedConfig) === null || _this$currentPredefin2 === void 0 ? void 0 : _this$currentPredefin2.text) || '';
    return String(raw).replaceAll('%logo%', '[LOGO]');
  }
  get isPredefinedUrl() {
    var _this$currentPredefin3, _this$currentPredefin4;
    const raw = String(((_this$currentPredefin3 = this.currentPredefinedConfig) === null || _this$currentPredefin3 === void 0 ? void 0 : _this$currentPredefin3.engraving) || ((_this$currentPredefin4 = this.currentPredefinedConfig) === null || _this$currentPredefin4 === void 0 ? void 0 : _this$currentPredefin4.text) || '');
    return /^https?:\/\//i.test(raw);
  }
  get predefinedColor() {
    var _this$currentPredefin5, _this$currentPredefin6;
    const raw = String(((_this$currentPredefin5 = this.currentPredefinedConfig) === null || _this$currentPredefin5 === void 0 ? void 0 : _this$currentPredefin5.color) || '').trim().toLowerCase();
    if (raw === 'nessun-colore' || raw === 'no-colore' || raw === 'nocolore' || raw === 'no color') {
      return '';
    }
    return String(((_this$currentPredefin6 = this.currentPredefinedConfig) === null || _this$currentPredefin6 === void 0 ? void 0 : _this$currentPredefin6.color) || '').trim();
  }
  get hasLockedPredefinedColor() {
    var _this$currentPredefin7;
    if (!this.isPredefined) return false;
    const raw = (_this$currentPredefin7 = this.currentPredefinedConfig) === null || _this$currentPredefin7 === void 0 ? void 0 : _this$currentPredefin7.color;
    if (raw === null || typeof raw === 'undefined') return false;
    const normalized = String(raw).trim();
    // Empty color means: text is predefined, color remains user-selectable.
    return normalized !== '';
  }
  get localName() {
    if (this.isPredefined) return this.predefinedText;
    const state = this.$store.state.configurator[this.nomeGetComp];
    return state ? state[this.fieldGetterName] : '';
  }
  set localName(value) {
    if (this.isPredefined) return;
    this.$store.commit(`${this.moduleName}/${this.nameMutation}`, value);
  }
  get localColor() {
    const state = this.$store.state.configurator[this.keyName];
    return state ? state[this.fieldGetterColor] : '';
  }
  set localColor(value) {
    if (this.isPredefined && this.hasLockedPredefinedColor) return;
    this.$store.commit(`${this.moduleName}/${this.colorMutation}`, value);
  }
  get activeColorName() {
    if (this.isPredefined && this.hasLockedPredefinedColor) {
      return this.predefinedColor;
    }
    return this.localColor || '';
  }
  get activeColorObj() {
    return this.colors.find(c => c.name === this.activeColorName) || {
      name: '',
      colorCode: ''
    };
  }
  get previewName() {
    if (this.isPredefined && this.isPredefinedUrl) return '';
    if (this.isPredefined) return this.predefinedText;
    return this.localName || '';
  }
  get namePlaceholder() {
    if (this.isPredefined) return this.predefinedText || '';
    return String(this.$t('message.Nome_personalizzato'));
  }
  selectColor(color) {
    if (this.isPredefined && this.hasLockedPredefinedColor) return;
    this.localColor = color.name;
  }
  isColorSelected(name) {
    return this.activeColorName === name;
  }
  textClear() {
    this.localName = '';
  }
  syncLockedPredefinedColor() {
    if (!this.isPredefined || !this.hasLockedPredefinedColor) return;
    const state = this.$store.state.configurator[this.keyName];
    if (!state) return;
    const current = String(state[this.fieldGetterColor] || '');
    if (current !== this.predefinedColor) {
      this.$store.commit(`${this.moduleName}/${this.colorMutation}`, this.predefinedColor);
    }
  }
  hideMobileKeyboardOnReturn() {
    // Implement your method
  }
  mounted() {
    this.syncLockedPredefinedColor();
  }
  updated() {
    this.syncLockedPredefinedColor();
  }
};
__decorate([Prop()], CustomLayout.prototype, "darkTheme", void 0);
__decorate([Prop()], CustomLayout.prototype, "colors", void 0);
__decorate([Prop()], CustomLayout.prototype, "previewComponent", void 0);
__decorate([Prop()], CustomLayout.prototype, "selectedColor", void 0);
__decorate([Prop()], CustomLayout.prototype, "astaColor", void 0);
__decorate([Prop()], CustomLayout.prototype, "keyName", void 0);
__decorate([Prop()], CustomLayout.prototype, "moduleName", void 0);
__decorate([Prop()], CustomLayout.prototype, "colorMutation", void 0);
__decorate([Prop()], CustomLayout.prototype, "nameMutation", void 0);
__decorate([Prop()], CustomLayout.prototype, "fieldGetterName", void 0);
__decorate([Prop()], CustomLayout.prototype, "fieldGetterColor", void 0);
__decorate([Prop()], CustomLayout.prototype, "nomeGetComp", void 0);
__decorate([Prop()], CustomLayout.prototype, "titlePreview", void 0);
CustomLayout = __decorate([Component], CustomLayout);
export default CustomLayout;